import {
  Box,
  Flex,
  Image,
  Text,
  Progress,
  VStack,
  Icon,
  Show,
  Hide,
  useDisclosure,
} from "@chakra-ui/react";
import CartIcon from "../../assets/blue_cart.png";
import FireIcon from "../../assets/mdi_fire.png";
import { formatMoney } from "../../utils";
import { Trans, t, msg } from "@lingui/macro";
import { useRouter } from "next/router";
import React from "react";
import Button from "../../components/Button";
import { HiFire } from "react-icons/hi";
import { FaShoppingCart } from "react-icons/fa";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";
import { FaShareNodes } from "react-icons/fa6";
import NextImage from "next/image";
import ShareModal from "../Wishlist/Share";

export default function WishlistCardPublic({ wishlist, currency, username, onClick, ...props }) {
  const router = useRouter();

  const {
    isOpen: isOpenShareModal,
    onOpen: onOpenShareModal,
    onClose: onCloseShareModal
  } = useDisclosure();

  const onClickDetail = () => {
    // router.push(`/overlays/wishlist/${wishlist.id}`);
    router.push(`/wishlist/${wishlist.id}`);
  };

  return (
    <>
      <Box
        w={{ base: "full", md: "full" }}
        h="100%"
        p="16px"
        bg="#F2F7F5"
        overflow="hidden"
        borderRadius="6px"
        border="1px solid #BEC1C1"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="16px"
        onClick={onClick}
        {...props}
        cursor={"pointer"}
      >
        {/* Top section */}
        <Box w="100%" display={{ base: "flex", md: "block" }} gap="16px">
          {/* Image with badge */}
          <Box
            position="relative"
            w={{ base: "68px", md: "100%" }}
            h={{ base: "68px", md: "296px" }}
            overflow="hidden"
            borderRadius="6px"
            mr={{ base: 4, md: 0 }}
          >
            <Image
              src={wishlist.image_url}
              alt={wishlist.product_name}
              w={{ base: "68px", md: "100%" }}
              h={{ base: "68px", md: "296px" }}
              borderRadius="6px"
              objectFit="cover"
            />
          </Box>

          {/* Details section */}
          <VStack
            flex={1}
            bg="#F2F7F5"
            spacing="12px"
            align="flex-start"
            mt={{ base: "0px", md: "16px" }}
          >
            {/* Title & menu */}
            <Flex alignItems="center" w="100%" mb={{ base: "0px", md: "12px" }}>
              <Text
                flex="1"
                fontSize={{ base: "sm", md: "md" }}
                fontFamily="IBM Plex Mono"
                fontWeight="700"
                wordBreak="break-word"
                noOfLines={{ base: 1, md: 2 }}
              >
                {wishlist.product_name}
              </Text>
            </Flex>

            {/* Progress and info */}
            <VStack spacing="8px" align="flex-start" w="100%">
              <Box w="full" h={{ base: "50px", md: "70px" }}>
                {wishlist.type === "CROWDFUND" && (
                  <Box w="100%" mb={{ base: "0px", md: "8px" }}>
                    <Progress
                      value={
                        (wishlist.total_donation / wishlist.total_price) * 100
                      }
                      size="sm"
                      borderRadius="99px" 
                      sx={{
                        "& > div": {
                          backgroundColor: "#3182CE",
                        },
                        backgroundColor: "#DDDEDE",
                      }}
                    />
                  </Box>
                )}

                <Flex
                  alignItems="center"
                  gap="8px"
                  mb={{ base: "0px", md: "8px" }}
                >
                  {wishlist.type === "FULLY_FUNDED" &&
                    wishlist.total_donation >= wishlist.total_price ? (
                    <Icon
                      as={FaCheckCircle}
                      boxSize="16px"
                      marginRight="8px"
                      color="#38A169"
                    />
                  ) : (
                    <Icon
                      as={HiFire}
                      boxSize="16px"
                      marginRight="8px"
                      color="#DD6B20"
                    />
                  )}

                  <Text
                    color="#DD6B20"
                    fontSize={{ base: "xs", md: "sm" }}
                    fontFamily="IBM Plex Mono"
                    fontWeight="600"
                    lineHeight="20px"
                  >
                    {wishlist.type === "FULLY_FUNDED" ? (
                      wishlist.total_donation >= wishlist.total_price ? (
                        <Trans>Udah ada yang beliin</Trans>
                      ) : (
                        <Trans>Beliin langsung yuk!</Trans>
                      )
                    ) : wishlist.total_donator > 0 ? (
                      <>
                        {wishlist.total_donator}{" "}
                        <Trans>orang ikut patungan</Trans>
                      </>
                    ) : (
                      <Trans>Ikut patungan yuk!</Trans>
                    )}
                  </Text>
                </Flex>

                <Flex alignItems="center" gap="8px" w="100%" mt="5px">
                  <Icon
                    as={FaShoppingCart}
                    boxSize="16px"
                    color="#3182CE"
                    marginRight="8px"
                  />
                  <Text
                    color="black"
                    fontSize={{ base: "xs", md: "sm" }}
                    fontFamily="IBM Plex Mono"
                    fontWeight="400"
                    lineHeight="20px"
                  >
                    {wishlist.ecommerce_name}
                  </Text>
                </Flex>
              </Box>
            </VStack>
          </VStack>
        </Box>
        <Box w="100%" mt={{ base: "10px", md: "4px" }}>
          <VStack spacing="20px" align="flex-start" w="100%">
            <Box>
              <Text
                as="span"
                color="black"
                fontSize="14px"
                fontFamily="IBM Plex Mono"
                fontWeight="400"
                lineHeight="20px"
              >
                {wishlist.type === "CROWDFUND" ? (
                  <>
                    <Trans>Terkumpul</Trans>{" "}
                  </>
                ) : (
                  ""
                )}
              </Text>
              <Text
                as="span"
                color="black"
                fontSize="16px"
                fontFamily="IBM Plex Mono"
                fontWeight="700"
                lineHeight="24px"
              >
                {wishlist.type === "CROWDFUND"
                  ? formatMoney(wishlist.total_donation, {
                    formatWithSymbol: true,
                    currency: currency ?? "IDR",
                  })
                  : formatMoney(wishlist.total_price, {
                    formatWithSymbol: true,
                    currency: currency ?? "IDR",
                  })}
              </Text>
            </Box>
          </VStack>
        </Box>
        <Box w="full" mt={{ base: "8px", md: "4px" }}>
          <Flex gap={3} w="100%">
            <Box
              position="relative"
              boxShadow="6.4px 6.4px 0px #222"
              borderRadius="6px"
              bg="#f2f7f5"
              border="1px solid #000"
              w="60px"
              h="42px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              p="9px 20px"
              mr={6}
              onClick={
                (e) => {
                  e.stopPropagation();
                  onOpenShareModal();
                }
              }
              cursor="pointer"
              _hover={{ bg: "#e8ede9" }}
              _active={{
                transform: "translate(1px, 1px)",
                boxShadow: "5.4px 5.4px 0 #222",
              }}
            >
              <Icon as={FaShareNodes} w="20px" h="20px" color="black" />
            </Box>

            <ShareModal isOpen={isOpenShareModal} onClose={onCloseShareModal} onOpen={onOpenShareModal} wishlist={wishlist} fonts={{ bodyFont: "IBM Plex Mono", titleFont: "Comfortaa", modalFont: "Inter" }} username={username} />

            <Button
              label={
                wishlist.type === "CROWDFUND"
                  ? t`Ikut Patungan`
                  : t`Beliin Langsung`
              }
              backgroundColor={
                wishlist.is_open ? "saweria-green.normal" : "#D8DCDB"
              }
              fontSize={{ base: "sm", md: "md" }}
              px={6}
              flexShrink={0}
              color={wishlist.is_open ? "black" : "#797B7A"}
              flex={1}
            />
          </Flex>
        </Box>

      </Box>
    </>
  );
}
